export function matchLang(av, def) {
  const l = window.navigator.languages.find((l) => {
    if (av.indexOf(l) >= 0) return l;
    return null;
  });
  return l || def;
}
